import * as types from '../../actions/types';

const loading = (state = { isLoading: false, component: '', loadingMessage: '', unique: {} }, action) => {
  switch (action.type) {
    case types.SET_LOADING:
      const { isLoading, component } = action;
      if (!isLoading) {
        // if component is undefined, hide spinner
        if (!component) {
          return {
            ...state,
            isLoading: false,
          };
        }

        // if action component is not the component that triggered loading
        // keep spinning
        if (component !== state.component) {
          return state;
        }
      }

      return {
        ...state,
        isLoading,
        component,
      };
    case types.SET_LOADING_MESSAGE:
      return { ...state, loadingMessage: action.message };
    case types.SET_LOADING_UNIQUE:
      return { ...state, unique: { ...state.unique, [action.component]: action.isLoading } };
    default:
      return state;
  }
};

export default loading;
